import { StepperSelectionEvent } from '@angular/cdk/stepper';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Inject,
  Injector,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatStepper } from '@angular/material/stepper';
import { Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { ListFideliteComponent } from '../list-fidelite/list-fidelite.component';
import * as _ from 'lodash';
import { GeneralService } from 'src/app/services/general.service';
import { ClientDialogComponent } from '../client-dialog/client-dialog.component';
import { DecimalPipe } from '@angular/common';
import { RechercheComponent } from 'src/app/recherche/recherche.component';
import { CaisseStateService } from './caisse-state.service';
import { ThumbsConstraints } from '@syncfusion/ej2-diagrams';
import { ThisReceiver } from '@angular/compiler';
import { threadId } from 'worker_threads';
import { th } from 'date-fns/locale';
import { forkJoin } from 'rxjs';
import { ConfirmComponent } from 'src/app/confirm/confirm.component';
import{WebViewService}from "../../web-view.service"


@Component({
  selector: 'app-caisse',
  templateUrl: './caisse.component.html',
  styleUrls: ['./caisse.component.scss'],
})
export class CaisseComponent implements OnInit, AfterViewInit, OnDestroy {
  //#region Init
  Doc_Num;
  Cash_Code;
  isOnwaitingState = false;
  @ViewChild('stepper') stepper: MatStepper;
  @ViewChild('numInput') numInput: ElementRef;
  @ViewChild('imgKastelo') imgKastelo: ElementRef<HTMLElement>;
  @ViewChild('inputQte') inputQte: ElementRef;
  @ViewChild('frmDialogModePayement') frmDialogModePayement;
  @ViewChild('frmTicketModePayment') frmTicketModePayment;
  @ViewChild('frmRemiseArticle') frmRemiseArticle;
  @ViewChild('frmSoldeCaisseOuverture') frmSoldeCaisseOuverture;
  @ViewChild('frmEchange') frmEchange;
  @ViewChild('frmAvance') frmAvance;
  @ViewChild('frmListeClient') frmListeClient;
  @ViewChild('frmListeArticle') frmListeArticle;
  @ViewChild('frmListeTicketTemp') tickettempfrm;
  @ViewChild('frmlisteStock') frmlisteStock;
  @ViewChild('addNewClient') frmaddNewClient;
  @ViewChild('client', { static: false }) client: RechercheComponent;
  @ViewChild('article', { static: false }) article: RechercheComponent;
  @ViewChild('ticketTempRech', { static: false }) ticketTempRech: RechercheComponent;
  codeTicketAvance
  data;
  api = environment.apiEndPoint;
  promise
  products = [];
  selectedItem;
  selectedEmployees = [];

  fullscreen = false;

  temperature;
  weather;
  meteo;

  articleTemp = '';
  waitedLength = 8;
  listTickets = [];
  ListTicketTemp = []
  ticketTemp = '';
  waitedTicketLength = 16;
  imageDomain = this.generalService.imageDomain;
  DocCashD_TxRem: number;
  DocCashD_Rem: number;
  Sto_Q: number;
  aRetenu = 0;
  montantArticleApretRemise;
  get sum() {
    //console.log(this.products);

    if (this.products.length == 0) {
      return 0;
    }
    return this.calculSum()
  }
  calculMontantTotalTicket(doccashD) {
    let somme = 0
    doccashD.forEach(element => {
      somme += element.DocCashD_PTTC
    });
    return somme
  }
  calculMontantPaye(doccashR) {
    let somme = 0
    doccashR.forEach(element => {
      console.log(element.DocCashR_Montant);
      console.log(somme);

      somme += element.DocCashR_Montant
    });
    return somme
  }
  validerAvance() {
    console.log(this.codeTicketAvance);
    console.log(this.dsDocCash);
    console.log(this.dsDocCashR);
    this.generalService.getDS('doccash', this.codeTicketAvance).subscribe((res: any) => {
      console.log(res);
      if (res.DocCashR[0].CashD_Id) {
        console.log(this.calculMontantTotalTicket(this.dsDocCash.DocCashTempD));
        console.log(this.calculMontantPaye(res.DocCashR));
        let s = this.calculMontantTotalTicket(this.dsDocCash.DocCashTempD) - this.calculMontantPaye(res.DocCashR)
        console.log(s);

        console.log(this.dsDocCashR);

        console.log(this.dsDocCashR);
        if (this.firstTimeIn) {
          this.dsDocCashR.DocCashR = []
          this.generalService.getDS('doccash').subscribe((resp: any) => {
            console.log(resp);
            let docCashR = Object.assign({}, resp.DocCashR[0])
            docCashR['DocCashR_Type'] = 8;
            docCashR['Doc_Num'] = this.Doc_Num;
            docCashR['CashD_Id'] = this.CashD_Id;
            docCashR['DocCashR_Montant'] = this.calculMontantPaye(res.DocCashR);
            this.dsDocCashR.DocCashR.push(JSON.parse(JSON.stringify(docCashR)));
            this.firstTimeIn = false
            this.sumPayed = this.generalService.roundToFixed(
              this.dsDocCashR.DocCashR.reduce(
                (a, b) => a + parseFloat(b.DocCashR_Montant),
                0
              )
            );
          })
        }
        else {
          this.generalService.getDS('doccash').subscribe((resp: any) => {
            console.log(resp);
            let docCashR = Object.assign({}, resp.DocCashR[0])
            docCashR['DocCashR_Type'] = 8;
            docCashR['Doc_Num'] = this.Doc_Num;
            docCashR['CashD_Id'] = this.CashD_Id;
            docCashR['DocCashR_Montant'] = this.calculMontantPaye(res.DocCashR);
            this.dsDocCashR.DocCashR.push(JSON.parse(JSON.stringify(docCashR)));
            console.log(this.dsDocCashR);
            this.sumPayed = this.generalService.roundToFixed(
              this.dsDocCashR.DocCashR.reduce(
                (a, b) => a + parseFloat(b.DocCashR_Montant),
                0
              )
            );
          })
        }
        this.closeDialog();
      }
      else {
        this.generalService.dialogSuccess(
          'Ticket n exicte pas ',
          false
        );
      }
      this.codeTicketAvance = null
    },
      error => {
        console.log(error);
      })
  }
  calculSum() {
    let s = 0
    //console.log(this.ListProductToshow);

    if (this.ListProductToshow)
      this.ListProductToshow.forEach(element => {
        s += element.PTAR
      });
    s = this.generalService.roundToFixed(s)
    return s
  }

  moyennePanier;
  tauxConvertion;
  nbVisite = 10;

  sumPayed = 0;

  selectedStepperIndex = 0;

  selectedCashR;

  dsDocCash: any = {};
  docCashR = [];

  ecartPermis = 0.0;

  numPiece: string = '';
  banque: string = '';
  value: number = 0;

  banques = this.generalService.banques;
  mode = 'NEW-TICKET';
  initDsDocCash;
  echeance = null;
  listenerKeyDownActive = true;
  codeTicket;
  codeArticle;
  scanning = false;
  journerOuvert = false;
  dsJournerOc;
  dsJourner;
  CashR_Type;
  listeCaisse = [];
  listeVendeur = [];
  selectedVendeur: any = {};
  selectedClient: any = {};
  selectedCaisse: any = {};
  CashD_Id;
  ListeTicketFormat;
  disabledCaisse = false;
  listeStock = [];
  listeStockIsloadet = false;
  columnStock;
  nomPassager = '';
  clientSelectedRow;
  pressKeyPoint: boolean = false;
  clientToAdd = {
    Tiers_Type: '01',
    Tiers_RS: '',
    Tiers_Adresse: '',
    Tiers_Ville: '',
    Tiers_Contact_mail: '',
    Tiers_Contact_Mobile: '',
    Tiers_Famille: '',
  };
  listeTicketNonTerminer = [];
  docCashToPost
  compte = 0;
  compteTicket = -1;
  ListCredit = [{
    viewValue: 'AVEC CREDIT',
    value: 'CREDIT'
  }, { viewValue: 'SANS CREDIT', value: 'NOCREDIT' }]
  constructor(
    private router: Router,
    public generalService: GeneralService,
    private CaisseStateService: CaisseStateService,
    private webview2 : WebViewService
  ) {
    this.btnCredit = false
    console.log(this.btnCredit);

    // this.generalService.getDS('Client').subscribe((res: any) => {
    //   console.log(res);
    // })
    // this.generalService.rechercheTable2('CashTicket').subscribe((res) => {
    //   this.ListeTicketFormat = res;
    //   console.log(res);

    // });
    this.generalService.getDS('doccash').subscribe(res => {
      this.docCashToPost = res
      this.dsDocCashR = res
      console.log(this.docCashToPost);
    })
  }
  btnCredit = false
  ngOnInit() {
    this.getdsDocCash();
    this.getListeCaisse();
    this.getListeVendeur();
    //this.getListeTypeReglement();
    this.listebuttons()
    this.getListeTicketFormat();
    this.openTicketTempList(false)

  }
  validerSelectionTicketTemp() {

  }

  listebuttons() {
    this.CashR_Type = [{ "DiverSys_Id": 915, "DiverSys_Type": "TRPOS", "DiverSys_Index": 0, "DiverSys_Titre": "reg type pos", "DiverSys_Libelle": "ESPECE", "DiverSys_Ordre": 0, "DiverSys_Group5": null, "DiverSys_Group4": null, "DiverSys_Group3": null, "DiverSys_Group2": null, "DiverSys_Group1": null, "DiverSys_Group": null, "DiverSys_Ecran": null, "U_timestamp": "AAAAAAAGx2M=" }, { "DiverSys_Id": 916, "DiverSys_Type": "TRPOS", "DiverSys_Index": 1, "DiverSys_Titre": "reg type pos", "DiverSys_Libelle": "CHEQUE", "DiverSys_Ordre": 1, "DiverSys_Group5": null, "DiverSys_Group4": null, "DiverSys_Group3": null, "DiverSys_Group2": null, "DiverSys_Group1": null, "DiverSys_Group": null, "DiverSys_Ecran": null, "U_timestamp": "AAAAAAAGx2Q=" }, { "DiverSys_Id": 917, "DiverSys_Type": "TRPOS", "DiverSys_Index": 2, "DiverSys_Titre": "reg type pos", "DiverSys_Libelle": "TPE", "DiverSys_Ordre": 2, "DiverSys_Group5": null, "DiverSys_Group4": null, "DiverSys_Group3": null, "DiverSys_Group2": null, "DiverSys_Group1": null, "DiverSys_Group": null, "DiverSys_Ecran": null, "U_timestamp": "AAAAAAAGx18=" }, { "DiverSys_Id": 918, "DiverSys_Type": "TRPOS", "DiverSys_Index": 5, "DiverSys_Titre": "reg type pos", "DiverSys_Libelle": "TICKET", "DiverSys_Ordre": 5, "DiverSys_Group5": null, "DiverSys_Group4": null, "DiverSys_Group3": null, "DiverSys_Group2": null, "DiverSys_Group1": null, "DiverSys_Group": null, "DiverSys_Ecran": null, "U_timestamp": "AAAAAAAGx2U=" }, { "DiverSys_Id": 926, "DiverSys_Type": "TRPOS", "DiverSys_Index": 6, "DiverSys_Titre": "reg type pos", "DiverSys_Libelle": "FIDELITE", "DiverSys_Ordre": 6, "DiverSys_Group5": null, "DiverSys_Group4": null, "DiverSys_Group3": null, "DiverSys_Group2": null, "DiverSys_Group1": null, "DiverSys_Group": null, "DiverSys_Ecran": null, "U_timestamp": "AAAAAAAHfSM=" }, { "DiverSys_Id": 941, "DiverSys_Type": "TRPOS", "DiverSys_Index": 7, "DiverSys_Titre": "reg type pos", "DiverSys_Libelle": "BA: ECHANGE / RETOUR", "DiverSys_Ordre": 7, "DiverSys_Group5": null, "DiverSys_Group4": null, "DiverSys_Group3": null, "DiverSys_Group2": null, "DiverSys_Group1": null, "DiverSys_Group": null, "DiverSys_Ecran": null, "U_timestamp": "AAAAAAAKOsU=" }, { "DiverSys_Id": 942, "DiverSys_Type": "TRPOS", "DiverSys_Index": 8, "DiverSys_Titre": "reg type pos", "DiverSys_Libelle": "Avance", "DiverSys_Ordre": 8, "DiverSys_Group5": null, "DiverSys_Group4": null, "DiverSys_Group3": null, "DiverSys_Group2": null, "DiverSys_Group1": null, "DiverSys_Group": null, "DiverSys_Ecran": null, "U_timestamp": "AAAAAAAKOsY=" }, { "DiverSys_Id": 944, "DiverSys_Type": "TRPOS", "DiverSys_Index": 9, "DiverSys_Titre": "reg type pos", "DiverSys_Libelle": "CREDIT", "DiverSys_Ordre": 9, "DiverSys_Group5": null, "DiverSys_Group4": null, "DiverSys_Group3": null, "DiverSys_Group2": null, "DiverSys_Group1": null, "DiverSys_Group": null, "DiverSys_Ecran": null, "U_timestamp": "AAAAAAAKOsQ=" }, { "DiverSys_Id": 999, "DiverSys_Type": "TRPOS", "DiverSys_Index": 10, "DiverSys_Titre": "reg type pos", "DiverSys_Libelle": "ARAMEX", "DiverSys_Ordre": 0, "DiverSys_Group5": null, "DiverSys_Group4": null, "DiverSys_Group3": null, "DiverSys_Group2": null, "DiverSys_Group1": null, "DiverSys_Group": null, "DiverSys_Ecran": null, "U_timestamp": "AAAAAAAGx2M=" }]
  }
  tbrFilter
  listWithoutFilter = []
  TicketTempselected = false
  //ticketTempRemise
  //solution with fork join
  ListToshowTrait(param) {
    this.TicketTempselected = true
    this.generalService.dialog.closeAll()
    this.generalService.getDS('doccashtemp', param).subscribe(res => {
      document.body.style.cursor = 'wait'
      this.products = []
      var list = []
      this.dsDocCash = res
      console.log(this.dsDocCash);
      console.log(this.dsDocCashR);

      var litsRemise = []
      if (this.dsDocCash.DocCashTempD[0].Art_Code) {
        this.dsDocCash.DocCashTempD.forEach(element => {
          litsRemise.push({ remise: element.DocCashD_TxRem, echange: element.Doc_NumO })
        })
        this.dsDocCash.DocCashTempD.forEach(element => {
          if (element.Art_Code) {
            list.push(this.generalService.rechercheTable('recherche/tbdata?tablere=articlef&param=' + element.Art_Code))
          }
        })
        forkJoin(list).subscribe(res => {
          console.log(res);
          res.map((e, i) => {
            console.log(litsRemise[i]);
            if (litsRemise[i].echange) {

              e[0].Art_Remise = litsRemise[i].remise
              if (e[0].Art_Remise != 0)
                e[0].PTAR = (e[0].Art_PV - ((e[0].Art_PV * e[0].Art_Remise) / 100)) * -1
              else
                e[0].PTAR = (e[0].Art_PV) * -1
              e[0]['Qte'] = 1 * -1

            }
            else {
              console.log(litsRemise[i].remise);
              //! allow change from backend
              e[0].Art_Remise = litsRemise[i].remise ? litsRemise[i].remise : e[0].Art_Remise
              if (e[0].Art_Remise != 0)
                e[0].PTAR = e[0].Art_PV - ((e[0].Art_PV * e[0].Art_Remise) / 100)
              else
                e[0].PTAR = e[0].Art_PV
              e[0]['Qte'] = 1
            }

            if (this.products.find((el) => el.Art_Code == e[0].Art_Code)) {
              this.products.find((el) => el.Art_Code == e[0].Art_Code).Qte += e[0].Qte
              this.products.find((el) => el.Art_Code == e[0].Art_Code).PTAR += e[0].PTAR
            }
            else {
              this.products.push(e[0])
              console.log(this.products);
            }
          })
          document.body.style.cursor = 'auto'
          this.ListProductToshow = this.products
        })
      }
      else
        document.body.style.cursor = 'auto'

    })
  }
  async promiseListToshow(param) {
    this.TicketTempselected = true
    console.log(param);
    //this.ticketTempRemise=param
    this.generalService.dialog.closeAll()
    this.promise = new Promise((resolve, reject) => {
      this.generalService.getDS('doccashtemp', param).subscribe(res => {
        this.products = []
        this.dsDocCash = res
        console.log(this.dsDocCash);
        this.dsDocCash.DocCashTempD.forEach(element => {
          if (element.Art_Code) {
            this.generalService.rechercheTable('recherche/tbdata?tablere=articlef&param=' + element.Art_Code
            )
              .subscribe((data) => {
                let obj = data[0]
                if (obj.Art_Code) {
                  obj.Art_Remise = element.DocCashD_TxRem
                  if (obj.Art_Remise != 0)
                    obj.PTAR = obj.Art_PV - ((obj.Art_PV * obj.Art_Remise) / 100)
                  else
                    obj.PTAR = obj.Art_PV
                  obj['Qte'] = 1
                  if (this.products.find((e) => e.Art_Code == obj.Art_Code)) {
                    this.products.find((e) => e.Art_Code == obj.Art_Code).Qte += obj.Qte
                    this.products.find((e) => e.Art_Code == obj.Art_Code).PTAR += obj.PTAR
                  }
                  else {
                    console.log(obj);
                    this.products.push(obj)
                    console.log(this.products);
                  }
                }
              })
          }
        })
        resolve(this.products)
      })
      console.log(this.promise);
      //this.products=this.dsDocCash.dsDocCashTempD
      if (this.dsDocCashR) {
        this.dsDocCashR.DocCashR = this.dsDocCashR.DocCashR = Object.assign({}, this.docCashToPost.DocCashR[0])
        console.log(this.dsDocCashR.DocCashR[0]);
      }
    })
    return this.promise
  }

  OpenTicketTemp(param) {
    // await this.getListProductToShow(param)
    this.ListToshowTrait(param)
    //this.getListProductToShow(param)
    // var p = await this.promiseListToshow(param)
    // setTimeout(() => {
    //   this.ListProductToshow = this.products
    // }, 1000);
  }

  //solution with incrmente value
  getListProductToShow(param) {
    this.TicketTempselected = true
    console.log(param);
    //this.ticketTempRemise=param
    this.generalService.dialog.closeAll()
    this.generalService.getDS('doccashtemp', param).subscribe(res => {
      this.products = []
      this.dsDocCash = res
      console.log(this.dsDocCash);
      this.dsDocCash.DocCashTempD.forEach(element => {
        if (element.Art_Code) {
          this.generalService.rechercheTable('recherche/tbdata?tablere=articlef&param=' + element.Art_Code
          )
            .subscribe((data) => {
              console.log(data);
              let obj = data[0]
              if (obj.Art_Code && (element.Doc_NumO == null || element.Doc_NumO)) {
                obj.Art_Remise = element.DocCashD_TxRem
                if (obj.Art_Remise != 0)
                  obj.PTAR = obj.Art_PV - ((obj.Art_PV * obj.Art_Remise) / 100)
                else
                  obj.PTAR = obj.Art_PV
                obj['Qte'] = 1
                if (this.products.find((e) => e.Art_Code == obj.Art_Code)) {
                  this.products.find((e) => e.Art_Code == obj.Art_Code).Qte += obj.Qte
                  this.products.find((e) => e.Art_Code == obj.Art_Code).PTAR += obj.PTAR
                }
                else {
                  console.log(obj);
                  this.products.push(obj)
                  console.log(this.products);
                }
              }
              else (obj.Art_Code && element.Doc_NumO)
              {
                obj.PTAR = element.DocCashD_PTTC
                obj['Qte'] = element.Sto_Q
              }
            })
        }
      });
      console.log(this.products);
      //this.products=this.dsDocCash.dsDocCashTempD
      if (this.dsDocCashR) {
        this.dsDocCashR.DocCashR = this.dsDocCashR.DocCashR = Object.assign({}, this.docCashToPost.DocCashR[0])
        console.log(this.dsDocCashR.DocCashR[0]);
      }
      //here load page +increment data
    })
    // increment data
    // setTimeout(() => {
    //   this.ListProductToshow = this.products
    // }, 2000);
  }
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  isloding = false
  openTicketTempList(opendialogue: Boolean) {
    if (opendialogue)
      this.generalService.dialogOpend = this.generalService.dialog.open(
        this.tickettempfrm,
        { minWidth: '600px', maxHeight: '90vh' }
      );

    this.isloding = false
    this.generalService.rechercheTable2('apiDocCach').subscribe(res => {
      this.ListTicketTemp = []
      this.listWithoutFilter = []
      console.log(res);

      this.tbrFilter = res
      this.tbrFilter.forEach(element => {
        let obj = {
          docNum: null,
          date: null,
          article: [],
          prixttl: 0
        }
        obj.docNum = element.Doc_Num
        obj.date = element.Doc_Date
        this.tbrFilter.filter(el => el.Doc_Num == element.Doc_Num).map(e => {
          let des = e.Art_Des
          let qte = e.QTotal
          let prix = e.PTTCTotal
          let code = e.Art_Code
          let remise = e.DocCashD_TxRem
          if (remise)
            obj.prixttl += (e.PTTCTotal * remise) / 100
          else
            obj.prixttl += e.PTTCTotal
          if (obj.article.find((e) => e.codeart == code)) {
            obj.article.find((e) => e.codeart == code).qte += qte
          }
          else
            obj.article.push({ des: des, qte: qte, prix: prix, remise: remise, codeart: code })
        })
        this.listWithoutFilter.push(obj)
      });

      let uniq = {}
      this.ListTicketTemp = this.listWithoutFilter.filter(obj => !uniq[obj.docNum] && (uniq[obj.docNum] = true))
      this.isloding = true
      console.log(this.ListTicketTemp);
      console.log(this.products);
    })
  }
  postAndGetDs() {
    this.generalService.postDs(this.dsDocCash).subscribe(res => {
      console.log(this.dsDocCash);
      this.echange = false
      this.generalService.getDS('doccashtemp', this.dsDocCash.DocCashTemp[0].Doc_Num).subscribe(res => {
        this.dsDocCash = res
        this.sumPayed = 0
        if (this.dsDocCashR) {
          this.dsDocCashR.DocCashR[0] = this.generalService.clearFields(this.dsDocCashR.DocCashR[0])
          if (this.dsDocCashR.DocCashR[1])
            this.dsDocCashR.DocCashR.splice(1, this.dsDocCashR.DocCashR.length)
        }
      })
      this.openTicketTempList(false)
      this.OpenTicketTemp(this.dsDocCash.DocCashTemp[0].Doc_Num)
    })

  }


  getListeTicketFormat() {
    this.generalService.rechercheTable2('CashTicket').subscribe((res) => {
      this.ListeTicketFormat = res;
      console.log(this.ListeTicketFormat);
    });
  }
  async getListeTypeReglement() {
    this.CashR_Type = await this.generalService
      .rechercheTable('DiverSys', 'trpos')
      .toPromise();
    // this.CashR_Type.push({
    //   DiverSys_Index: 7,
    //   DiverSys_Libelle: 'BA : Echange/Retour',
    //   DiverSys_Ordre: 7,
    // });
    // this.CashR_Type.push({
    //   DiverSys_Index: 8,
    //   DiverSys_Libelle: 'BA:Avance',
    //   DiverSys_Ordre: 8,
    // });
    // this.CashR_Type.push({
    //   DiverSys_Index: 9,
    //   DiverSys_Libelle: 'CREDIT ' + this.btnCredit,
    //   DiverSys_Ordre: 9,
    // });
  }

  ngAfterViewInit() {
    Promise.resolve(null).then(() => {
      this.setSelectedStepperIndex();
      if (this.CaisseStateService.CaisseComponent) {
        this.CaisseStateService.setPreviousState(this);
      }
    });

  }

  ngOnDestroy() {
    this.CaisseStateService.CaisseComponent = this;
  }
  setSelectedStepperIndex() {
    this.selectedStepperIndex = this.stepper.selectedIndex;
  }

  getdsDocCash() {
    this.generalService.getDS('doccashTemp').subscribe((ds: any) => {
      this.initDsDocCash = ds;
      this.firstTimeIn = true
      this.getdsJourner();
    });
  }

  getListeCaisse() {
    let user = window.localStorage.getItem('userInfo');
    let username = user.substring(user.indexOf("userName") + 11, user.indexOf("email") - 3)
    this.generalService
      .rechercheTable(this.generalService.url + 'Cash&param=' + username)
      .subscribe((data) => {
        this.listeCaisse = data;
      });
  }

  getListeVendeur() {
    this.generalService
      .rechercheTable(this.generalService.url + 'avtperso&param=0')
      .subscribe((data) => {
        this.listeVendeur = data;
      });
  }
  //#endregion

  //#region Functions
  openStock() {
    this.listenerKeyDownActive = false;
    this.generalService
      .rechercheTable('recherche/tbdata?tablere=stockcash&param=' + this.selectedCaisse.Cash_Code)
      .subscribe((data) => {
        this.listeStock = data;
        this.listeStockIsloadet = true;
      });
    this.generalService
      .rechercheTable('recherche/TbRecherche?param=stockcash&param=' + this.selectedCaisse.Cash_Code)
      .subscribe((data) => {
        this.columnStock = data;
      });
    this.generalService.dialogOpend = this.generalService.dialog.open(
      this.frmlisteStock,
      { minWidth: '400px' }
    );
    this.generalService.dialogOpend.afterClosed().subscribe(() => {
      this.listenerKeyDownActive = true;
    });
  }
  btnFid =null
  clientSelected(row) {
    console.log(row);
    if (row.Tiers_Famille == 'CREDIT') {
      this.btnCredit = true
    }
    else {
      this.btnCredit = false
    }
    if (row.Tiers_PointM > 0) {
      this.btnFid = row.Tiers_PointM
    }
    else {
      this.btnFid = false
    }
    this.clientSelectedRow = row;
  }
  selectionClientChange(code) {
    if (this.isOnwaitingState) return;
    this.isOnwaitingState = true;
    this.generalService
      .rechercheTable(
        this.generalService.urlFindDoc + code + ',' + 'client' + ',' + 'avatar'
      )
      .subscribe(
        (data) => {
          this.isOnwaitingState = false;

          if (data != undefined && data != null && data.length > 0) {
            this.client.selectedRow.image =
              data[data.length - 1].File_Autre +
              data[data.length - 1].File_Content;
          }
        },
        (err) => {
          this.isOnwaitingState = false;
        }
      );
  }
  validerSelectionClient() {
    if (this.client.selectedRow) {
      this.selectedClient = this.client.selectedRow;
      this.dsDocCash.DocCashTemp[0].Doc_RS = this.selectedClient.Tiers_RS;
      this.dsDocCash.DocCashTemp[0].Tiers_Code = this.selectedClient.Tiers_Code;
    }
    this.closeDialog();
  }
  LastItemSelected
  async validerSelectionArticle() {

    // if (this.mode == 'ECHANGE') {
    //   const item = await this.generalService
    //     .rechercheTable(
    //       'recherche/tbdata?tablere=articlef&param=' + this.article.selectedRow.Art_Code
    //     )
    //     .toPromise();
    //   item[0].Qte = 1
    //   item[0].PTAR = (item[0].Art_PV - ((item[0].Art_PV * item[0].Art_Remise) / 100))
    //   if (this.products.find(e => e.Art_Code == item[0].Art_Code)) {
    //     this.products.find(e => e.Art_Code == item[0].Art_Code).Qte += 1
    //     this.products.find(e => e.Art_Code == item[0].Art_Code).PTAR += item[0].PTAR
    //     this.LastItemSelected = this.products.find((e) => e.Art_Code == this.article.selectedRow.Art_Code)
    //     this.addArticleDS(this.LastItemSelected, 1);
    //     console.log(this.dsDocCash);

    //   }
    //   else {
    //     this.addItem(item[0], 1);
    //   }
    //   this.closeDialog();
    // }
    // else {
    console.log(this.products.find((e) => e.Art_Code == this.article.selectedRow.Art_Code));
    console.log(this.article.selectedRow);

    if (this.products.find((e) => e.Art_Code == this.article.selectedRow.Art_Code)) {
      this.LastItemSelected = this.products.find((e) => e.Art_Code == this.article.selectedRow.Art_Code)
      this.addArticleDS(this.LastItemSelected, 1);
      console.log(this.dsDocCash);
      this.generalService.postDs(this.dsDocCash).subscribe(res => {
        console.log(this.dsDocCash);
        this.generalService.getDS('doccashtemp', this.dsDocCash.DocCashTemp[0].Doc_Num).subscribe(res => {
          this.dsDocCash = res
          this.LastItemSelected.Qte += 1
          this.firstTimeIn = true
          this.sumPayed = 0
          if (this.dsDocCashR) {
            this.dsDocCashR.DocCashR[0] = this.generalService.clearFields(this.dsDocCashR.DocCashR[0])
            if (this.dsDocCashR.DocCashR[1])
              this.dsDocCashR.DocCashR.splice(1, this.dsDocCashR.DocCashR.length)
          }
        })
        this.firstTimeIn = true
        if (this.dsDocCashR) {
          this.dsDocCashR.DocCashR = this.dsDocCashR.DocCashR = Object.assign({}, this.docCashToPost.DocCashR[0])
          console.log(this.dsDocCashR.DocCashR[0]);
        }
        this.openTicketTempList(false)
        // setTimeout(() => {
        //   this.updateTicketTemp(this.dsDocCash.DocCashTemp[0].Doc_Num)
        // }, 100);
        this.OpenTicketTemp(this.dsDocCash.DocCashTemp[0].Doc_Num)
      })
    }
    else
      if (this.article.selectedRow) {
        const item = await this.generalService
          .rechercheTable(
            'recherche/tbdata?tablere=articlef&param=' + this.article.selectedRow.Art_Code

          )
          .toPromise();
        this.addItem(item[0], 1);
        //this.addItem(this.article.selectedRow, 1);
      }
    this.closeDialog();
    console.log(this.products);
    // }
  }
  selectCaisse(caisse) {
    if (this.dsJournerOc) {
      this.selectedCaisse = caisse;
      // if(this.selectedVendeur.Perso_Matricule)
      // this.setTDsJournerOc(this.selectedCaisse.Cash_Code);
    } else
      this.generalService.dialogSuccess(
        'Veuillez patienter pendant le chargement total des données',
        false
      );
  }

  ListProductToshow



  pressKeyZero
  writeNumber(num) {
    let val;
    if (num.toString() == '0') this.pressKeyZero = true;
    else if (num.toString() == '.') this.pressKeyPoint = true;
    else {
      if (this.pressKeyPoint || this.pressKeyZero) {
        if (this.pressKeyPoint) {
          this.pressKeyPoint = false;
          val = this.value.toString() + '.' + num.toString();
        }
        else if (this.pressKeyZero) {
          this.pressKeyZero = false;
          val = this.value.toString() + '0' + num.toString();
        }

      } else {
        if (num == 0) {
          val = this.value.toString() + num.toString();
          console.log(val);
          console.log(this.value);

        }
        else {
          val = isNaN(this.value)
            ? num.toString()
            : this.value.toString() + num.toString();
        }


      }
      this.value = parseFloat(val);
    }

    this.numInput.nativeElement.focus();

    // this.numInput.nativeElement.
  }
  deleteReglement(reglement, index) {
    console.log('delete reglement');

    if (reglement.DocCashR_Montant > 0) {
      console.log(this.dsDocCashR.DocCashR[index]);

      if (this.dsDocCashR.DocCashR[index].DocCashR_Type != 9) {
        this.sumPayed -= reglement.DocCashR_Montant;
      }
      this.dsDocCashR.DocCashR.splice(index, 1);
      var docCashR = [];
      for (var i = 0; i < this.dsDocCashR.DocCashR.length; i++) {
        if (this.dsDocCashR.DocCashR[i].DocCashR_Montant > 0) {
          docCashR.push(this.dsDocCashR.DocCashR[i]);
        } else {
          console.log(this.dsDocCashR.DocCashR[i]);
          this.sumPayed -= this.dsDocCashR.DocCashR[i].DocCashR_Montant;
          this.aRetenu += this.dsDocCashR.DocCashR[i].DocCashR_Montant;

        }
      }
      this.dsDocCashR.DocCashR = docCashR;
      this.addRetourReglement();
    }
  }
  delCaractaire() {
    this.value = parseInt(
      this.value.toString().substring(0, this.value.toString().length - 1)
    );
    this.value = this.generalService.roundToFixed(this.value);
  }
  // ! CHECK THIS
  getRest() {
    // console.log(this.sum);
    // console.log(this.sumPayed);
    // console.log(this.value);

    var value = this.sum - this.sumPayed - this.value;
    value = this.generalService.roundToFixed(value);
    //console.log(value);
    return value;
    // if (value >= 0) return value;
    // else return 0;
  }
  getReste(): any {
    console.log(2);

    if (this.dsDocCash && this.dsDocCash.DocCashR) {
      var aRendre = -this.dsDocCash.DocCashR.filter((reg) => {
        return reg.DocCashR_Montant < 0;
      }).reduce((a, b) => a + parseInt(b.DocCashR_Montant), 0);
      if (aRendre > 0) {
        return this.generalService.roundToFixed(aRendre);
      } else return 0;
    } else return 0;
  }
  setUserConnecter() {
    if (this.generalService.user)
      this.dsJournerOc.CashD[0].UserName = this.generalService.user.userName;
    setTimeout(() => {
      this.setUserConnecter();
    }, 100);
  }
  getdsJourner() {
    if (this.isOnwaitingState) return;
    this.isOnwaitingState = true;

    this.generalService
      .rechercheTable('recherche/tbdata?tablere=CashD')
      .subscribe(
        (data3) => {
          if (data3.length == 1) {
            this.disabledCaisse = true;
            this.CashD_Id = data3[0].CashD_Id;
            this.journerOuvert = true;
            if (data3[0].Cash_Code)
              this.selectedCaisse.Cash_Code = data3[0].Cash_Code;
            this.initVariable();
            this.isOnwaitingState = false;
          } else {
            this.disabledCaisse = false;
            this.generalService
              .rechercheTable('ds/formdata?code=CashDoc')
              .subscribe((data) => {
                this.dsJournerOc = data;
                this.setUserConnecter();
                this.isOnwaitingState = false;
              });
          }
          this.newTicket()
        },
        (err) => {
          this.isOnwaitingState = false;
        }
      );
  }
  selectItem(item) {
    this.selectedItem = item;
  }
  firsttimeechange
  addItem(item, quantiter) {
    let deleteitem = false
    let find = false
    if (this.isOnwaitingState) return;
    this.isOnwaitingState = true;
    if (item) {
      if (!this.products.find((e) => e.Art_Code == item.Art_Code)) {
        item.Qte = 0;
        this.products.push(item);
      }
      item.Qte += quantiter;

      if (item.Qte <= 0) {
        this.products = this.products.filter(
          (p) => p.Art_Code != item.Art_Code
        );
      }

      this.selectedItem = item;
      this.DocCashD_TxRem = this.maxBetween(
        this.clientSelectedRow,
        item,
        'Tiers_Remise',
        'Art_Remise'
      );
      this.montantArticleApretRemise = this.selectedItem.Art_PV;
      this.Sto_Q = this.selectedItem.Qte;
      this.selectedItem.DocCashD_TxRem = this.DocCashD_TxRem;
      console.log(quantiter);

      if (quantiter > 0) {
        console.log(this.mode);

        console.log(this.dsDocCash);
        // if (this.mode == 'ECHANGE') {
        //   this.addArticleDS(item, 1);
        //   if (!this.firsttimeechange) {
        //     console.log('in');
        //     this.dsDocCash.DocCashTemp[0].Doc_Ref = this.dsDocCash.DocCashTempD[0].Doc_Num
        //     this.dsDocCash.DocCashTempD[0].Doc_Num = this.dsDocCash.DocCashTemp[0].Doc_Num
        //     this.dsDocCash.DocCashTempD[0].U_timestamp = null
        //     this.firsttimeechange = true
        //     this.ListProductToshow = this.products
        //   }
        //   else {
        //     console.log('else');
        //     console.log(item);
        //     console.log(this.products.find(e => e.Art_Code == item.Art_Code));
        //     console.log(this.products.find(e => e.Art_Code == item.Art_Code) && this.products.find(e => e.Art_Code == item.Art_Code).Qte > 1);

        //     if (this.products.find(e => e.Art_Code == item.Art_Code) && this.products.find(e => e.Art_Code == item.Art_Code).Qte > 1) {
        //       console.log('find');
        //       this.products.find(e => e.Art_Code == item.Art_Code).PTAR += (item.Art_PV - ((item.Art_PV * item.Art_Remise) / 100))
        //     }
        //     // else
        //     // {
        //     //   this.products.find(e => e.Art_Code == item.Art_Code).Qte += 1
        //     // }
        //     this.ListProductToshow = this.products
        //   }

        // }
        // else {

        this.addArticleDS(item, quantiter);
        this.postAndGetDs()
        // }
      }
      else if (quantiter < 0) {
        deleteitem = true
        let i;
        console.log(this.dsDocCash);

        this.dsDocCash.DocCashTempD.forEach((element, index) => {
          if (element.Art_Code == item.Art_Code && !find) {
            i = index
            console.log(index);
            find = true
            //item.Qte -= 1
          }
        });
        console.log(this.echange);

        if (!this.echange) {
          if (this.dsDocCash.DocCashTempD[i].DocCashD_Id) {
            this.generalService.delete(this.dsDocCash.DocCashTempD[i].DocCashD_Id, 'DocCashTempDdel').subscribe(res => {
              document.body.style.cursor = 'wait'
              console.log(res);
              this.dsDocCash.DocCashTempD.splice(i, 1)
              //if (this.dsDocCash.DocCashTempD.length > 0) {
              this.generalService.getDS('doccashtemp', this.dsDocCash.DocCashTemp[0].Doc_Num).subscribe(res => {
                this.dsDocCash = res
                this.postAndGetDs()
                if (this.dsDocCash.DocCashTempD[0].Art_Code == null) {
                  document.body.style.cursor = 'auto'
                  this.ListProductToshow = []
                }
              })
              document.body.style.cursor = 'auto'
            })

          }
        }
      }
      // else {
      //   console.log('quantite negative et echange');
      //   console.log(this.products);
      //   console.log(this.ListProductToshow);
      //   console.log(item);
      //   this.dsDocCash.DocCashTempD.splice(i, 1)
      //   console.log(this.dsDocCash);
      //   let itemsinList = this.ListProductToshow.find(e => e.Art_Code == item.Art_Code)
      //   console.log(itemsinList);
      //   if (itemsinList) {

      //     console.log(' else viderliste');
      //     console.log(itemsinList);
      //     console.log(quantiter);
      //     console.log(item.Art_PV - ((item.Art_PV * item.Art_Remise) / 100));
      //     itemsinList.PTAR -= item.Art_PV - ((item.Art_PV * item.Art_Remise) / 100)
      //     console.log(itemsinList);

      //     if (itemsinList.Qte == 0) {
      //       console.log('in qte==0');

      //       let j;
      //       this.ListProductToshow.forEach((element, index) => {
      //         if (element.Art_Code == item.Art_Code) {
      //           j = index
      //           console.log(index);
      //         }
      //       });
      //       console.log(this.ListProductToshow.find(e => e.Art_Code == item.Art_Code));

      //       this.ListProductToshow.find(e => e.Art_Code == item.Art_Code).Qte -= quantiter
      //       this.ListProductToshow.find(e => e.Art_Code == item.Art_Code).PTAR -= item.Art_PV - ((item.Art_PV * item.Art_Remise) / 100)
      //       this.ListProductToshow.splice(j, 1)
      //     }

      //   }

      // }
      console.log(this.ListProductToshow);
      // }

      this.validerRemise();
      this.calculerMontantRemiseArticle();

      if (this.dsDocCash.DocCashTemp[0]) {
        if (!this.generalService.isNotEmpty(this.dsDocCash.DocCashTemp[0].Doc_TTTC))
          this.dsDocCash.DocCashTemp[0].Doc_TTT = 0;
        else
          this.dsDocCash.DocCashTemp[0].Doc_TTT = parseFloat(
            this.dsDocCash.DocCashTemp[0].Doc_TTT
          );
        this.dsDocCash.DocCashTemp[0].Doc_TTTC += parseInt(item.Art_PV);

        if (!this.generalService.isNotEmpty(this.dsDocCash.DocCashTemp[0].Doc_THT))
          this.dsDocCash.DocCashTemp[0].Doc_THT = 0;
        else
          this.dsDocCash.DocCashTemp[0].Doc_THT = parseFloat(
            this.dsDocCash.DocCashTemp[0].Doc_THT
          );
        this.dsDocCash.DocCashTemp[0].Doc_THT += 0; //parseInt(item.Art_PV)
      }
    }
    this.isOnwaitingState = false;

    console.log(this.ListProductToshow);
  }
  addArticleDS(item, quantiter) {
    console.log(item);

    let newDS = JSON.parse(JSON.stringify(this.initDsDocCash.DocCashTempD[0]));
    newDS.Art_Code = item.Art_Code;
    newDS.Art_Des = item.Art_Des;
    newDS.Doc_Num = this.mode == 'NEW-TICKET' || 'ECHANGE' ? this.Doc_Num : this.codeTicket;
    newDS.Sto_Q = quantiter;
    newDS.DocCashD_PTTC = item.Art_PV;
    newDS.DocCashD_PUHTN = item.Art_PV;
    newDS.DocCashD_PUHTB = item.Art_PV;
    console.log(this.dsDocCash);

    if (this.dsDocCash.DocCashTempD) {
      if (!this.TicketTempselected)
        this.dsDocCash.DocCashTempD.push(newDS);
      else {
        newDS.Doc_Num = this.dsDocCash.DocCashTemp[0].Doc_Num
        this.dsDocCash.DocCashTempD.push(newDS);
      }
    }
  }
  maxBetween(a, b, keyA, keyB) {
    if (!a || !this.selectedClient.Tiers_RS) return b[keyB];
    return a[keyA] > b[keyB] ? a[keyA] : b[keyB];
  }
  //#region Nouvelle Ticket
  newTicket() {
    this.btnCredit = false
    document.body.style.cursor = 'auto'
    this.firsttimeechange = true
    this.TicketTempselected = false
    if (this.journerOuvert) {
      if (this.verifierExistanceReglement()) {
        //this.fromAvance=false
        this.mode = 'NEW-TICKET';
        this.dsDocCash.DocCashTemp[0].Doc_Type = '0';
        if (this.products.length > 0 && this.compteTicket == -1) {
          var ticket = {
            compte: this.compte,
            dsDocCash: this.dsDocCash,
            sumPayed: this.sumPayed,
            products: this.products,
            //cashRList: this.dsDocCash.DocCashR,
          };
          this.listeTicketNonTerminer.push(JSON.parse(JSON.stringify(ticket)));
          this.compte++;
        }
        this.generalService.getDS('doccash').subscribe(res => {
          let ds = res
          console.log(res);
          this.dsDocCashR = ds
          // this.dsDocCashR.dsDocCashR.splice(0,1)
        })
        this.initVariable();
        this.closeSelectedItem();
        this.products = [];
        this.firstTimeIn = true
        this.echange = false
        this.ListProductToshow = []
        this.compteTicket = -1;
        this.caseAvance = null;
        this.generalService.dialogSuccess(
          'Une nouvelle ticket ',
          true
        );
      }
    } else
      this.generalService.dialogSuccess(
        'Appuyez sur le bouton Ouverture pour pouvoir démarrer',
        false
      );
  }

  setTicket(ticket) {
    if (this.verifierExistanceReglement()) {
      if (this.products.length > 0 && this.compteTicket == -1) {
        this.newTicket();
      }
      this.mode = 'NEW-TICKET';
      this.dsDocCash = ticket.dsDocCash;
      this.sumPayed = ticket.sumPayed;

      this.products = ticket.products;
      //this.updateTicketTemp(this.dsDocCash.DocCashTemp[0].Doc_Num)
      this.OpenTicketTemp(this.dsDocCash.DocCashTemp[0].Doc_Num)
      this.dsDocCash.DocCashR = ticket.cashRList;
      this.compteTicket = ticket.compte;
      this.closeSelectedItem();
    }
  }
  verifierExistanceReglement() {
    if (
      !(this.dsDocCash && this.dsDocCash.DocCashR) ||
      this.dsDocCash.DocCashR.length == 0
    )
      return true;
    else {
      this.generalService.dialogSuccess(
        'Payer le ticket pour pouvoir en faire un autre',
        false
      );
      return false;
    }
  }

  //#endregion
  initVariable() {
    this.Doc_Num = new Date().getTime();
    this.closeSelectedItem();
    this.initDsDocCash.DocCashTemp[0].Cash_Code = this.selectedCaisse.Cash_Code;
    this.initDsDocCash.DocCashTemp[0].Doc_Num = this.Doc_Num;
    this.initDsDocCash.DocCashTemp[0].Doc_Date = new Date();
    this.initDsDocCash.DocCashTemp[0].CashD_Id = this.CashD_Id;
    this.dsDocCash = JSON.parse(JSON.stringify(this.initDsDocCash));
    this.dsDocCash.DocCashTempD = [];
    //this.dsDocCash.DocCashR = [];
    this.TicketTempselected = false
    this.sumPayed = 0;
    this.selectedClient = {};
    this.stepper.selectedIndex = 0;
  }
  validerTicket() {
    console.log(this.ListProductToshow);
    console.log(this.mode);

    if (this.mode == 'AVANCE') {
      if (!this.selectedClient.Tiers_RS) {
        this.generalService.dialogSuccess(
          'Vous devez sélectionner un client',
          false
        );
        return;
      }

      if (this.sumPayed <= 0) {
        console.log(this.sumPayed);

        this.generalService.dialogSuccess('Le montant est invalide', false);
        return;
      }
    }
    if (this.mode == 'RETOUR') {
      if (this.sum == 0) {
        this.generalService.dialogSuccess(
          'Veuillez sélectionner un article de retour',
          false
        );
        return;
      }
    }

    this.dsDocCashR.DocCash = this.dsDocCash.DocCashTemp
    this.dsDocCashR.DocCashD = this.dsDocCash.DocCashTempD
    this.dsDocCashR.DocCash[0].U_timestamp = null
    this.dsDocCashR.DocCashD.forEach(element => {
      element.U_timestamp = null
    });
    this.dsDocCashR.DocCashR.forEach(element => {
      element.Doc_Num = this.dsDocCashR.DocCash[0].Doc_Num

    });
    console.log(this.dsDocCashR);
    this.generalService.getDS('doccash').subscribe(res => {
      let ds = res
      ds["DocCash"] = this.dsDocCashR.DocCashTemp
      ds["DocCashD"] = this.dsDocCashR.DocCashTempD
      this.dsDocCashR.DocCashR.forEach(element => {
        element.Doc_Num = this.dsDocCashR.DocCash[0].Doc_Num
        element.DocCashR_Montant = parseInt(element.DocCashR_Montant)
      });
    })
    console.log(this.mode);

    if (
      this.sumPayed - parseFloat(this.sum.toFixed(3)) == 0 ||
      this.sumPayed - parseFloat(this.sum.toFixed(3)) == 0 ||
      this.mode == 'RETOUR' ||
      this.mode == 'ECHANGE' ||
      this.mode == 'AVANCE'
    ) {
      if (this.products.length > 0 || this.mode == 'AVANCE') {
        if (this.selectedVendeur && this.selectedVendeur.Perso_Matricule)
          console.log(this.dsDocCash);

        this.dsDocCash.DocCashTemp[0].Rep_Code = this.selectedVendeur.Perso_Matricule;
        if (this.products.length > 0 && (this.mode == 'RETOUR' || this.mode == 'ECHANGE')) {
          console.log(this.dsDocCash);
          console.log(this.dsDocCashR);
          //this.dsDocCashR.DocCash[0].Doc_Ref = this.dsDocCash.DocCashTemp[0].Doc_Num
        }
        this.generalService.enregisterTable(this.dsDocCashR).subscribe(() => {
          this.generalService.dialogSuccess('Valider **', true);
          console.log(" ////  ",this.Doc_Num);
          this.generalService.delete(this.dsDocCash.DocCashTemp[0].Doc_Num, 'doccashTemp').subscribe(res => {
            console.log(res);
            this.openTicketTempList(false)
          })
          //window.location.reload()
          this.printPrice();

          if (this.compteTicket != -1) {
            this.listeTicketNonTerminer = this.listeTicketNonTerminer.filter(
              (t) => {
                return t.compte != this.compteTicket;
              }
            );
          }
          this.mode = 'NEW-TICKET';
          this.initVariable();
          this.closeSelectedItem();
          this.products = [];
          this.firstTimeIn = true
          this.ListProductToshow = []
          this.caseAvance = null;
          this.dsDocCashR.DocCashR = Object.assign({}, this.docCashToPost.DocCashR[0])
          this.compteTicket = -1;
        });
      } else this.generalService.dialogSuccess('Le panier est vide', false);
    }
    //credit
    else if (this.dsDocCashR.DocCashR[0].DocCashR_Type == 9) {
      console.log(111111);

      this.generalService.enregisterTable(this.dsDocCashR).subscribe(() => {
        this.generalService.delete(this.dsDocCash.DocCashTemp[0].Doc_Num, 'doccashTemp').subscribe(res => {
          console.log(res);
          this.openTicketTempList(false)
        })
        this.generalService.dialogSuccess('Valider', true);
        console.log(" +++++++ " ,this.Doc_Num);
        this.openTicketTempList(false)
        //window.location.reload()
        this.printPrice();

        // if (this.compteTicket != -1) {
        //   this.listeTicketNonTerminer = this.listeTicketNonTerminer.filter(
        //     (t) => {
        //       return t.compte != this.compteTicket;
        //     }
        //   );
        // }
        this.initVariable();
        this.closeSelectedItem();
        this.firstTimeIn = true
        this.products = [];
        this.dsDocCashR.DocCashR = Object.assign({}, this.docCashToPost.DocCashR[0])
        this.ListProductToshow = []
        this.compteTicket = -1;
        this.TicketTempselected = false
        this.caseAvance = null;
      });
    }
    else {
      console.log(this.sumPayed - parseInt(this.sum.toFixed(3)));
      this.generalService.dialogSuccess('Le montant est invalide', false);
      console.log(this.sumPayed, this.sum, parseFloat(this.sum.toFixed(3)));
    }
  }

  credit(param) {
    if (this.mode != 'AVANCE') {
      let type = this.getCashRByIndex(param);
      this.generalService.getDS('doccash').subscribe(res => {
        this.dsDocCashR = res
        //this.dsDocCashR.DocCashR.splice(1)
        this.dsDocCashR.DocCashR[0].DocCashR_Type = type['DiverSys_Index'];
        this.dsDocCashR.DocCashR[0].Doc_Num = this.Doc_Num;
        this.dsDocCashR.DocCashR[0].CashD_Id = this.CashD_Id;
        this.dsDocCashR.DocCashR[0].Doc_Ref = this.numPiece;
        this.dsDocCashR.DocCashR[0].DocCashR_Montant = this.sum
      })
    }
    else {
      this.generalService.dialogSuccess('Impossible de faire un crédit', false);
    }

    // var docCashR = Object.assign({}, this.docCashToPost.DocCashR[0])
    // docCashR.DocCashR_Type = type['DiverSys_Index'];
    // docCashR.Doc_Num = this.Doc_Num;
    // docCashR.CashD_Id = this.CashD_Id;
    // docCashR.Doc_Ref = this.numPiece;
    // docCashR.DocCashR_Montant = this.sum

    // if (this.firstTimeIn) {
    //   var changeDocTempTodoc = this.docCashToPost
    //   changeDocTempTodoc.DocCash[0] = this.generalService.fillObject(this.dsDocCash.DocCashTemp[0], changeDocTempTodoc.DocCash[0])
    //   changeDocTempTodoc.DocCashD = this.dsDocCash.DocCashTempD
    //   changeDocTempTodoc.DocCashR[0] = docCashR
    // this.generalService.delete(this.dsDocCash.DocCashTemp[0].Doc_Num, 'doccashTemp').subscribe(res => {
    //   console.log(res);
    // })
    //   this.dsDocCashR = changeDocTempTodoc
    //   this.firstTimeIn = false
    // }
    // console.log(this.dsDocCashR);

    //   if (docCashR.DocCashR_Montant != 0) {
    //     console.log(5);
    //     this.dsDocCashR.DocCashR.push(JSON.parse(JSON.stringify(docCashR)));
    //   }
  }
  //ticketContent
  firstTimeIn = true
  dsDocCashR
  addCashR() {
    let isElse = false
    // ? prevent adding twice
    if (this.isOnwaitingState) return;
    this.isOnwaitingState = true;

    // ? 'espece' / 'tpe' / 'cheque' ..
    let type = this.getCashRByIndex(this.selectedCashR);

    this.generalService.getDS('doccash').subscribe(res => {
      console.log(res);
      let ds = res
      //this.docCashToPost = res
      // var docCashR = JSON.parse(JSON.stringify(this.initDsDocCash.DocCashR[0]));
      // var docCashR = JSON.parse(JSON.stringify(this.docCashToPost.DocCashR[0]))
      console.log(this.dsDocCashR);

      // if (this.mode == 'NEW-TICKET') {
      //   if (this.dsDocCashR.DocCashR[0].DocCashR_Montant == null)
      //     this.dsDocCashR.DocCashR.splice(0, 1)
      // }
      var docCashR = Object.assign({}, res["DocCashR"][0])
      console.log(docCashR);
      docCashR['DocCashR_Type'] = type['DiverSys_Index'];
      docCashR['Doc_Num'] = this.Doc_Num;
      docCashR['CashD_Id'] = this.CashD_Id;
      //premier mode de paiment
      if (this.firstTimeIn) {
        var changeDocTempTodoc = this.docCashToPost
        changeDocTempTodoc.DocCash[0] = this.generalService.fillObject(this.dsDocCash.DocCashTemp[0], changeDocTempTodoc.DocCash[0])
        changeDocTempTodoc.DocCashD = this.dsDocCash.DocCashTempD
        console.log(docCashR);
        console.log(changeDocTempTodoc.DocCashR);
        changeDocTempTodoc.DocCashR = ds["DocCashR"]
        this.dsDocCashR = changeDocTempTodoc
        this.dsDocCashR.DocCashR.splice(0, 1)
        console.log('first time');
        //this.dsDocCashR.DocCashR[0]['DocCashR_Montant']=0
      }


      console.log(this.dsDocCashR);
      // if(this.dsDocCashR.DocCashR.length>0)
      // {
      //   if(this.dsDocCashR.DocCashR[0].DocCashR_Type)
      //   {

      var totalCheque = this.dsDocCashR.DocCashR.filter((reg) => {
        return reg.DocCashR_Type == 1;
      }).reduce((a, b) => a + parseInt(b.DocCashR_Montant), 0);
      var totalTpe = this.dsDocCashR.DocCashR.filter((reg) => {
        return reg.DocCashR_Type == 2;
      }).reduce((a, b) => a + parseInt(b.DocCashR_Montant), 0);
      var totalTicket = this.dsDocCashR.DocCashR.filter((reg) => {
        return reg.DocCashR_Type == 5;
      }).reduce((a, b) => a + parseInt(b.DocCashR_Montant), 0);
      var totalFidalite = this.dsDocCashR.DocCashR.filter((reg) => {
        return reg.DocCashR_Type == 6;
      }).reduce((a, b) => a + parseInt(b.DocCashR_Montant), 0);
      //var somme=0
      if (totalCheque)
        var somme = totalCheque + totalTpe + totalTicket + totalFidalite;
      //espece
      if (type['DiverSys_Index'] == 0) {
        if (this.value != 0) {
          console.log(this.value);

          if (this.dsDocCashR.DocCashR.find(e => e.DocCashR_Type == 0)) {
            this.dsDocCashR.DocCashR.find(e => e.DocCashR_Type == 0).DocCashR_Montant += this.value
          }
          else {
            docCashR['DocCashR_Montant'] = this.value;
            this.dsDocCashR.DocCashR.push(JSON.parse(JSON.stringify(docCashR)));
          }
        }
      }
      else if (type['DiverSys_Index'] == 10) {
        if (this.value != 0) {
          console.log(this.value);
          console.log(type);

          if (this.dsDocCashR.DocCashR.find(e => e.DocCashR_Type == 10)) {
            this.dsDocCashR.DocCashR.find(e => e.DocCashR_Type == 10).DocCashR_Montant += this.value
          }
          else {
            docCashR['DocCashR_Montant'] = this.value;
            this.dsDocCashR.DocCashR.push(JSON.parse(JSON.stringify(docCashR)));
          }
        }
      }
      //tpe
      else if (type['DiverSys_Index'] == 2) {
        if (this.dsDocCashR.DocCashR.length == 0) {
          somme = 0
          if (somme + this.value <= this.sum) {
            docCashR['Doc_Ref'] = this.numPiece;
            docCashR['DocCashR_Montant'] = this.value;
          }
        }
        else if (this.value <= this.sum) {
          docCashR['Doc_Ref'] = this.numPiece;
          docCashR['DocCashR_Montant'] = this.value;
        }
        else {
          isElse = true
        }
      }
      //cheque
      else if (type['DiverSys_Index'] == 1) {
        console.log("cheque");

        if (this.dsDocCashR.DocCashR.length == 0) {
          console.log("if");
          somme = 0
          if (somme + this.value <= this.sum) {
            docCashR.Doc_Banque = this.banque;
            docCashR.Doc_Ref = this.numPiece;
            docCashR.Doc_ChqEch = this.echeance;
            docCashR.DocCashR_Montant = this.value + '';
          }
        }
        else if (this.value <= this.sum) {
          console.log("else");
          docCashR.Doc_Banque = this.banque;
          docCashR.Doc_Ref = this.numPiece;
          docCashR.Doc_ChqEch = this.echeance;
          docCashR.DocCashR_Montant = this.value + '';
        }
        else {
          isElse = true
        }
      }
      //ticket
      else if (type['DiverSys_Index'] == 5) {
        console.log('Ticket');

        if (this.dsDocCashR.DocCashR.length == 0) {
          somme = 0
          if (somme + this.value <= this.sum) {
            docCashR['Doc_Ref'] = this.numPiece;
            docCashR['DocCashR_Montant'] = this.value + '';
          }
        }
        else if (this.value <= this.sum) {
          docCashR['Doc_Ref'] = this.numPiece;
          docCashR['DocCashR_Montant'] = this.value + '';
        }
        else {
          isElse = true
        }
      }
      // fidalite
      else if (type['DiverSys_Index'] == 6) {
        if (this.dsDocCashR.DocCashR.length == 0) {
          somme = 0
          if (somme + this.value <= this.sum) {
            docCashR['DocCashR_Montant'] = this.value + '';
          }
        }
        else if (this.value <= this.sum) {
          docCashR['DocCashR_Montant'] = this.value + '';
        }

        else {
          isElse = true
        }
      }
      //BA echange /retour
      else if (type['DiverSys_Index'] == 7) {
        if (this.value > 0) {
          this.generalService.dialogSuccess(
            'Règlement négatifs uniquement',
            false
          );

        }
        else {
          docCashR['Doc_Ref'] = this.numPiece;
          docCashR['DocCashR_Montant'] = this.value * (-1);
          if (this.sum < 0)
            this.sumPayed = this.sum
        }
      }
      else if (type['DiverSys_Index'] == 8) {
        if (this.value > 0) {
          docCashR['Doc_Ref'] = this.numPiece;
          docCashR['DocCashR_Montant'] = this.value;
          this.sumPayed = this.value
        }
        else {
          this.generalService.dialogSuccess(
            'Règlement Positive uniquement',
            false
          );
        }
      }
      console.log(this.dsDocCashR);


      if (docCashR['DocCashR_Montant'] >= 0 || type['DiverSys_Index'] == 7) {
        if (type['DiverSys_Index'] == 5) {
          this.listTickets.forEach((ticket) => {
            if (!this.dsDocCashR.DocCashR.find(e => e.Doc_Ref == ticket.codeComplete)) {
              if (docCashR['DocCashR_Montant'] != 0) {
                console.log(ticket.CashTicket_Montant);
                console.log(1);

                this.dsDocCashR.DocCashR.push({
                  ...docCashR,
                  DocCashR_Montant: ticket.CashTicket_Montant,
                  Doc_Ref: ticket.codeComplete,
                });
              }
            }
            else {
              this.generalService.dialogSuccess(
                'Code deja scanné',
                false
              );
            }
          });
        }
        else {
          if (docCashR['DocCashR_Montant'] != -0) {
            if (type['DiverSys_Index'] != 7 && type['DiverSys_Index'] != 0 && type['DiverSys_Index'] != 10) {
              if (docCashR['DocCashR_Montant'] != 0) {
                console.log(this.dsDocCashR);
                console.log(this.dsDocCashR.length);
                this.dsDocCashR.DocCashR.push(JSON.parse(JSON.stringify(docCashR)));
                console.log(this.dsDocCashR.length);
                console.log("ahlaa");
                console.log(this.dsDocCashR);
                console.log("ahlaa");
                this.closeDialog();
              }
            }
            else if ((type['DiverSys_Index'] == 7) && (this.value < 0)) {
              if (docCashR['DocCashR_Montant'] != 0) {
                this.dsDocCashR.DocCashR.push(JSON.parse(JSON.stringify(docCashR)));
                this.closeDialog();
                console.log("ahlaa2");
              }
            }
          }
        }
        if (!this.dsDocCashR.DocCashR[0].DocCashR_Montant) {
          this.dsDocCashR.DocCashR.shift(0)
        }
        if (type['DiverSys_Index'] != 7) {
          this.sumPayed = this.generalService.roundToFixed(
            this.dsDocCashR.DocCashR.reduce(
              (a, b) => a + parseFloat(b.DocCashR_Montant),
              0
            )
          );
          console.log(this.sumPayed);
        }
        if (this.mode != 'AVANCE') this.addRetourReglement();
        this.generalService.dialogOpend.close();
        console.log(this.sumPayed);

        console.log(this.dsDocCashR.DocCashR);
      } else {
        this.generalService.dialogSuccess(
          'La somme des paiements Chèque, Ticket et TPE ne doit pas excéder la somme des articles',
          false
        );
      }
      if (!isElse) {
        this.aRetenu += this.value - this.sumPayed;
        this.closeDialog();
        this.isOnwaitingState = false;
      }
      else {
        this.generalService.dialogSuccess(
          'Une erreur se produite',
          false
        );
      }
      this.firstTimeIn = false

      console.log(this.dsDocCashR);
      console.log(this.dsDocCashR);
      console.log(this.dsDocCash);
      console.log(this.ListProductToshow);
      console.log(this.products);

    })
  }
  refocus() {
    setTimeout(() => {
      const input = document.getElementById('hiddenInput');
      //input.focus();
    }, 800);
  }
  addRetourReglement() {
    console.log('retour reglement');
    console.log(this.sumPayed);
    console.log(this.sum);

    if (this.sumPayed > this.sum) {
      // var docCashR = JSON.parse(JSON.stringify(this.docCashToPost.DocCashR[0]));
      // var docCashR = JSON.parse(JSON.stringify(this.docCashToPost.DocCashR[0]));

      var docCashR = Object.assign({}, this.docCashToPost.DocCashR[0])
      docCashR.Doc_Num = this.Doc_Num;
      docCashR.CashD_Id = this.CashD_Id;
      docCashR.DocCashR_Type = 0;
      docCashR.DocCashR_Montant = this.generalService.roundToFixed(
        -(this.sumPayed - this.sum)
      );

      if (this.dsDocCashR.DocCashR.find(e => e.DocCashR_Montant < 0))
        this.dsDocCashR.DocCashR.find(e => e.DocCashR_Montant < 0).DocCashR_Montant += docCashR.DocCashR_Montant
      else
        if (docCashR.DocCashR_Montant != 0) {
          this.dsDocCashR.DocCashR.push(JSON.parse(JSON.stringify(docCashR)));
        }

      this.sumPayed = this.generalService.roundToFixed(
        this.dsDocCashR.DocCashR.reduce(
          (a, b) => a + parseFloat(b.DocCashR_Montant),
          0
        )
      );
    }
  }

  getCashRByIndex(id) {
    var reglement = this.CashR_Type.find((e) => e.DiverSys_Index == id);
    if (reglement) return reglement;
    else return {};
  }
  getLibeleReglement(id) {
    return this.getCashRByIndex(id)['DiverSys_Libelle'];
  }
  getIconReglement(id) {
    return this.getCashRByIndex(id)['icon'];
  }

  selectCash(selected) {
    if (selected == 6 && !this.btnFid) {
      this.generalService.dialogSuccess("n'est pas autorisée", false)
      return
    }
    if (selected == 8) {
      this.generalService.dialogOpend = this.generalService.dialog.open(
        this.frmAvance
      );
    }
    else {


      console.log(selected);
      if (this.dsDocCashR)
        console.log(this.dsDocCashR);

      if (selected == 9)
        this.credit(selected)
      else {
        if (this.initDsDocCash) {
          if (this.products.length > 0 || this.mode == 'AVANCE') {
            if ((selected == 1 || selected == 6) && !this.selectedClient.Tiers_RS) {
              this.generalService.dialogSuccess(
                'Pour pouvoir accepter un chèque, vous devez sélectionner un client',
                false
              );
              this.openClientList(selected);
              return;
            }

            this.selectedCashR = selected;
            console.log(this.value);
            console.log(this.sumPayed);
            console.log(this.sum);

            if (selected == 6 && this.btnFid) {
              this.value =this.btnFid
              // (this.sum > 0 ? this.sum : 0) - (this.sumPayed ? this.sumPayed : 0);
            }
            else
              this.value =
                (this.sum > 0 ? this.sum : 0) - (this.sumPayed ? this.sumPayed : 0);
            this.value = this.generalService.roundToFixed(this.value);
            if (selected == 7) {
              if (this.getRest() < 0) {
                this.value = this.getRest()
              }
              else
                this.value *= -1;
            }
            if (selected !== 5) {
              this.generalService.dialogOpend = this.generalService.dialog.open(
                this.frmDialogModePayement
              );
            } else {
              this.scanning = true;
              this.refocus();
              this.keyDown = ""
              this.generalService.dialogOpend = this.generalService.dialog.open(
                this.frmTicketModePayment
              );
            }
            setTimeout(() => {
              this.numInput.nativeElement.select();


            }, 300);
            this.generalService.dialogOpend.afterClosed().subscribe((result) => {
              this.value = 0;
              this.scanning = false;
              this.banque = '';
              this.numPiece = '';
              this.listTickets = [];
            });
          } else
            this.generalService.dialogSuccess(
              'Veuillez sélectionner un article pour pouvoir ajouter un réglement',
              false
            );
        } else
          this.generalService.dialogSuccess(
            'Veuillez patienter pendant le chargement total des données',
            false
          );
      }
    }
  }

  TextVal = "";
  // scannedWithPmK() {
  //   console.log(1);
  //   const code = this.TextVal;
  //   this.TextVal = "";

  //   if (!this.scanning) return;
  //   const id = code.substring(0, 3);
  //   const ticketFormat = this.ListeTicketFormat.find(
  //     (e) => e.CashTicket_Nature == id
  //   );

  //   if (!id || !ticketFormat) {
  //     this.generalService.dialogSuccess('code invalid', false);
  //     console.log(this.ListeTicketFormat);
  //     console.log(this.TextVal);
  //     return;
  //   }
  //   if (ticketFormat.CashTicket_Nb !== code.length) {
  //     this.generalService.dialogSuccess('code trop court', false);
  //     return;
  //   }
  //   if (this.listTickets.find((t) => t.codeComplete == code)) {
  //     this.generalService.dialogSuccess('Code deja exist !', false);
  //     return;
  //   }

  //   this.listTickets.push({
  //     codeComplete: code,
  //     CashTicket_Code: id,
  //     CashTicket_Fournisseur: ticketFormat.CashTicket_Fournisseur,
  //     CashTicket_Libelle: ticketFormat.CashTicket_Libelle,
  //     CashTicket_Montant: Number(code.substring(3, 9)) / 1000,
  //   });
  //   this.value = this.listTickets.reduce((a, b) => a + b.CashTicket_Montant, 0);
  // }
  deleteTicketPayment(index) {
    this.listTickets.splice(index, 1);
    this.value = this.listTickets.reduce((a, b) => a + b.CashTicket_Montant, 0);
  }
  closeSelectedItem() {
    this.selectedItem = null;
  }
  removeArticle() {
    if (this.selectedItem) {
      // this.toastr.success('Article supprimé');
      this.closeSelectedItem();
    }
  }
  validerQte() {
    if (this.Sto_Q > 0 == false) {
      this.inputQte.nativeElement.focus();
      setTimeout(() => {
        this.Sto_Q = 1;
        this.calculerMontantRemiseArticle();
      }, 100);
    }
  }
  calculerMontantRemiseArticle() {
    if (this.Sto_Q > 0) {
      if (
        this.DocCashD_Rem &&
        this.DocCashD_Rem > 0 &&
        this.DocCashD_Rem < this.selectedItem.Art_PV
      ) {
        this.montantArticleApretRemise = this.arrendiMontant(
          this.selectedItem.Art_PV - this.DocCashD_Rem
        );
        this.DocCashD_TxRem = this.arrendiMontant(
          (100 / this.selectedItem.Art_PV) * this.DocCashD_Rem
        );
      } else {
        this.montantArticleApretRemise = this.selectedItem.Art_PV;
        this.DocCashD_TxRem = null;
        this.DocCashD_Rem = null;
      }
    } else {
      // setTimeout(()=>
      // {
      //   this.Sto_Q = 1
      // },100)
    }
    this.calculerMontantArticle();
  }
  calculerTauxRemiseArticle() {
    if (
      this.DocCashD_TxRem &&
      this.DocCashD_TxRem > 0 &&
      this.DocCashD_TxRem < 100
    ) {
      this.montantArticleApretRemise = this.arrendiMontant(
        this.selectedItem.Art_PV -
        this.selectedItem.Art_PV * (this.DocCashD_TxRem / 100)
      );
      this.DocCashD_Rem = this.arrendiMontant(
        this.selectedItem.Art_PV - this.montantArticleApretRemise
      );
    } else {
      this.montantArticleApretRemise = this.selectedItem.Art_PV;
      this.DocCashD_TxRem = null;
      this.DocCashD_Rem = null;
    }
    this.calculerMontantArticle();
  }
  calculerMontantArticle() {
    if (this.Sto_Q >= 0)
      this.montantArticleApretRemise =
        this.montantArticleApretRemise * this.Sto_Q;
    else this.montantArticleApretRemise = 0;
  }

  arrendiMontant(valeur) {
    var decimalPipe = new DecimalPipe('fr-FR');
    var valeurArrandi = decimalPipe.transform(valeur, '0.3-3');
    valeurArrandi = valeurArrandi.replace(/ /g, '').replace(',', '.');
    return parseFloat(valeurArrandi);
  }
  openFrmRemiseArticle() {
    if (this.journerOuvert) {
      if (this.selectedStepperIndex == 0)
        if (this.verifierExistanceReglement())
          if (this.selectedItem) {
            if (this.selectedItem.Qte > 0) {
              this.listenerKeyDownActive = false;
              this.generalService.dialogOpend = this.generalService.dialog.open(
                this.frmRemiseArticle,
                { disableClose: true }
              );
              this.montantArticleApretRemise = this.selectedItem.Art_PV;
              this.Sto_Q = this.selectedItem.Qte;
              this.generalService.dialogOpend
                .afterClosed()
                .subscribe((result) => {
                  this.listenerKeyDownActive = true;
                });
            } else
              this.generalService.dialogSuccess(
                'Vous ne pouvez pas appliquer une remise pour un article de retour',
                false
              );
          } else
            this.generalService.dialogSuccess(
              'Veuillez sélectionner un article',
              false
            );
    } else
      this.generalService.dialogSuccess(
        'Appuyez sur le bouton Ouverture pour pouvoir démarrer',
        false
      );
  }
  validerRemise() {
    if (this.Sto_Q > 0) {
      if (!this.DocCashD_Rem) {
        this.DocCashD_Rem = 0;
        this.DocCashD_TxRem = 0;
      }
      this.selectedItem.Qte = this.Sto_Q;
      this.selectedItem.DocCashD_PTTC = this.montantArticleApretRemise;
      this.selectedItem.DocCashD_Rem = this.DocCashD_Rem;
      this.selectedItem.DocCashD_TxRem = this.DocCashD_TxRem;
      var art = this.dsDocCash.DocCashTempD.find((art) => {
        return art.Art_Code == this.selectedItem.Art_Code;
      });
      if (art) {
        art.DocCashD_Rem = this.DocCashD_Rem;
        art.DocCashD_TxRem = this.DocCashD_TxRem;
        art.DocCashD_PUB = this.selectedItem.Art_PV; // + art.DocCashD_Rem;
        art.DocCashD_PUN = art.DocCashD_PUB - art.DocCashD_Rem;
        art.DocCashD_PTTC = art.DocCashD_PUN * art.Sto_Q;
      }
      this.closeDialog();
      this.DocCashD_Rem = null;
      this.DocCashD_TxRem = null;
    }
  }
  closeDialog() {
    this.generalService.dialog.closeAll();
  }
  echange = false
  validerEchange() {
    if (this.codeTicket && this.codeArticle) {
      this.generalService
        .rechercheTable(
          'recherche/tbdata?tablere=DocCashDRetour&param=' +
          this.codeTicket +
          ',' +
          this.codeArticle
        )
        .subscribe(async (data) => {
          console.log(data);
          if (data.length > 0) {
            const item = await this.generalService
              .rechercheTable(
                'recherche/tbdata?tablere=articlef&param=' + this.codeArticle
              )
              .toPromise();
            this.firsttimeechange = false
            this.echange = true
            this.addItem(item[0], -1);
            item[0].PTAR = data[0].DocCashD_PTTC * -1
            data[0].Doc_NumO = data[0].Doc_Num
            data[0].Doc_Num = this.dsDocCash.DocCashTemp[0].Doc_Num
            data[0].U_timestamp = null
            //data[0].Sto_Q=data[0].Sto_Q*-1
            //data[0].DocCashD_PTTC=data[0].DocCashD_PTTC*-1
            this.dsDocCash.DocCashTempD.push(data[0])
            this.products.push(item[0])
            this.ListProductToshow.push(item[0])
            console.log(this.ListProductToshow);

            //this.dsDocCashR = Object.assign({}, this.docCashToPost)
            //console.log(this.dsDocCashR);

            this.dsDocCashR.DocCashR[0].DocCashR_Type =
              this.mode == 'ECHANGE' ? '1' : '2';
            this.closeDialog();
          } else
            this.generalService.dialogSuccess(
              'Le code ticket et/ou le code article est invalide',
              false
            );

          this.codeTicket = null;
          this.codeArticle = null;
        });
    } else {
      this.generalService.dialogSuccess(
        'veuillez saisir un code ticket et un code article',
        false
      );
    }
    //this.updateTicketTemp(this.dsDocCash.DocCashTemp[0].Doc_Num)
  }
  // fromAvance=false
  addAvance() {
    this.btnCredit = false
    if (this.journerOuvert) {
      if (this.verifierExistanceReglement()) {
        this.newTicket();
        this.mode = 'AVANCE';
        this.dsDocCashR.DocCash[0].Doc_Type = '5';
        //this.fromAvance=true
        this.openClientList();
      }
    } else
      this.generalService.dialogSuccess(
        'Appuyez sur le bouton Ouverture pour pouvoir démarrer',
        false
      );
  }
  lastMode
  caseAvance
  AvanceTicket() {
    console.log(this.caseAvance);
    if (!this.caseAvance) {
      const dialogConfig = this.generalService.dialogConfig;
      dialogConfig.autoFocus = true;
      var dialogRef = this.generalService.dialog.open(
        ConfirmComponent,
        dialogConfig
      );
      dialogRef.afterClosed().subscribe((result) => {
        console.log(result);

        if (result == 'Confirmer') {
          this.lastMode = this.mode
          this.mode = 'AVANCE';
          console.log(this.mode);
        }
      })
    }
    else
      this.mode = this.lastMode;
    console.log(this.mode);

    //this.dsDocCashR.DocCash[0].Doc_Type = '5';
  }

  openFrmEchange(mode) {
    this.btnCredit = false
    if (this.journerOuvert) {
      if (this.verifierExistanceReglement()) {
        this.newTicket();
        this.mode = mode;
        this.listenerKeyDownActive = false;
        this.generalService.dialogOpend = this.generalService.dialog.open(
          this.frmEchange
        );
        this.generalService.dialogOpend.afterClosed().subscribe(() => {
          this.listenerKeyDownActive = true;
        });
      }
    } else
      this.generalService.dialogSuccess(
        'Appuyez sur le bouton Ouverture pour pouvoir démarrer',
        false
      );
  }
  openfrmAvance() {

  }
  selectVendeur(employee) {
    this.selectedVendeur = employee;
  }
  removeEmployee() {
    this.selectedVendeur = {};
  }

  toggleFullscreen() {
    if (this.fullscreen) {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      }
    } else {
      if (document.documentElement.requestFullscreen) {
        document.documentElement.requestFullscreen();
      }
    }
    this.fullscreen = !this.fullscreen;
  }

  openClientDetails() {
    this.generalService.dialog.open(ClientDialogComponent);
  }

  goToSituationReglement() {
    if (this.verifierExistanceReglement()) {
      if (this.generalService.isNotEmpty(this.CashD_Id))
        this.router.navigate(['/avt/close/' + this.CashD_Id, '0']);
      else
        this.generalService.dialogSuccess(
          'Veuillez sélectionner une caisse',
          false
        );
    }
  }

  openCloseDay() {
    if (this.verifierExistanceReglement()) {
      if (this.journerOuvert) {
        if (this.generalService.isNotEmpty(this.CashD_Id))
          this.router.navigate(['/avt/close/' + this.CashD_Id, '1']);
        // else
        // if(this.selectedCaisse.Cash_Code )
        //   this.newDay()
      } else {
        if (this.selectedCaisse.Cash_Code) {
          if (this.dsJournerOc) {
            this.dsJournerOc.CashD[0].Cash_Code = this.selectedCaisse.Cash_Code;
            this.dsJournerOc.CashD[0].CashD_Id =
              this.selectedCaisse.Cash_Code + '-' + new Date().getTime();
            this.CashD_Id = this.dsJournerOc.CashD[0].CashD_Id;
            this.dsJournerOc.CashD[0].CashD_DateO = new Date();
            this.generalService.dialogOpend = this.generalService.dialog.open(
              this.frmSoldeCaisseOuverture
            );
            this.generalService.dialogOpend
              .afterClosed()
              .subscribe((result) => {
                this.generalService
                  .enregisterTable(this.dsJournerOc)
                  .subscribe((data) => {
                    this.journerOuvert = true;
                    this.initVariable();
                  });
              });
          } else
            this.generalService.dialogSuccess(
              'Veuillez patienter pendant le chargement total des données',
              false
            );
        } else
          this.generalService.dialogSuccess(
            'Veuillez sélectionner une caisse',
            false
          );
      }
    }
  }

  openTicketList() {
    if (this.verifierExistanceReglement())
      this.router.navigate(['/avt/ticket-list']);
  }

  openArticleList() {
    if (this.journerOuvert) {
      this.listenerKeyDownActive = false;
      this.generalService.dialogOpend = this.generalService.dialog.open(
        this.frmListeArticle
      );
      this.generalService.dialogOpend.afterClosed().subscribe((result) => {
        this.listenerKeyDownActive = true;
      });
    } else
      this.generalService.dialogSuccess(
        'Appuyez sur le bouton Ouverture pour pouvoir démarrer',
        false
      );
  }

  openClientList(selected?) {
    console.log(this.btnCredit);
    if (this.dsDocCash) {
      this.listenerKeyDownActive = false;
      this.generalService.dialogOpend = this.generalService.dialog.open(
        this.frmListeClient
      );
      this.generalService.dialogOpend.afterClosed().subscribe((result) => {
        this.listenerKeyDownActive = true;
        if (selected && this.selectedClient.Tiers_RS) this.selectCash(selected);
      });
    } else
      this.generalService.dialogSuccess(
        'Veuillez patienter pendant le chargement total des données',
        false
      );
  }

  openFideliteList() {
    this.generalService.dialog.open(ListFideliteComponent);
  }

  goToTicketList() {
    this.router.navigate(['/avt/ticket-list']);
  }

  cnrt = false
  @HostListener('document:keydown', ['$event'])
  keyClicked(event) {
    if (this.journerOuvert && this.selectedStepperIndex == 0 && (this.mode == 'NEW-TICKET' ||
      this.mode == 'RETOUR' || this.mode == 'ECHANGE') && this.listenerKeyDownActive) {
      //console.log(1);
      this.handleKeyDown(event.key, event.keyCode, event);
    }
    // console.log(this.lastIndex);

    if (this.lastIndex != 3) {
      //console.log(2);
      //this.scannedWithPmK()
      this.keyTicket(event.key, event.keyCode, event);
    }

    this.handelShortCuts(event.key, event.keyCode, event);
  }

  handelShortCuts(key, keyCode, event: Event) {
    const ReglementTypesIndexes = this.CashR_Type.map((e) => e.DiverSys_Index);
    const reglementTypesKeySelectors = [
      'F5',
      'F6',
      'F7',
      'F8',
      'F9',
      'F10',
      'F11',
    ];
    if (key == 'F1') {
      event.preventDefault();
      event.stopPropagation();
      if (this.stepper.selectedIndex >= 2) {
        this.stepper.selectedIndex = 0;
      } else this.stepper.next();
    } else if (reglementTypesKeySelectors.includes(key)) {
      event.preventDefault();
      event.stopPropagation();
      this.selectCash(
        ReglementTypesIndexes[reglementTypesKeySelectors.indexOf(key)]
      );
    }
  }
  lastIndex = -1
  indexCLiked(param) {
    //console.log(param);
    this.lastIndex = -param

  }
  scannedWithPm(e) {
    e.stopPropagation();
    e.preventDefault();
    this.keyDown = "";
    // Get pasted data via clipboard API
    const clipboardData = e.clipboardData;
    const code = clipboardData.getData('Text');
    this.keyDown = code
    if (!this.scanning) return;
    const id = code.substring(0, 3);
    const ticketFormat = this.ListeTicketFormat.find(
      (e) => e.CashTicket_Nature == id
    );

    if (!id || !ticketFormat) {
      this.generalService.dialogSuccess('code invalid', false);
      this.keyDown = ""
      console.log(this.ListeTicketFormat);
      console.log(ticketFormat);
      return;
    }
    if (ticketFormat.CashTicket_Nb !== code.length) {
      this.generalService.dialogSuccess('code trop court', false);
      console.log(this.ListeTicketFormat);
      console.log(ticketFormat);
      this.keyDown = ""
      return;
    }
    if (this.listTickets.find((t) => t.codeComplete == code)) {
      this.generalService.dialogSuccess('Code deja exist !', false);
      this.keyDown = ""
      console.log(ticketFormat);
      return;
    }
    this.keyDown = code

    this.listTickets.push({
      codeComplete: code,
      CashTicket_Code: id,
      CashTicket_Fournisseur: ticketFormat.CashTicket_Fournisseur,
      CashTicket_Libelle: ticketFormat.CashTicket_Libelle,
      CashTicket_Montant: Number(code.substring(3, 9)) / 1000,
    });
    this.value = this.listTickets.reduce((a, b) => a + b.CashTicket_Montant, 0);
  }


  keyDown = ""
  keyTicket(key, keyCode, event: Event) {
    // console.log(this.keyDown);
    if (
      (keyCode > 47 && keyCode < 58) ||
      (keyCode > 64 && keyCode < 91) ||
      (keyCode >= 96 && keyCode <= 105) ||
      key == '-' ||
      key == '*' ||
      key == '_' ||
      key == '.' ||
      key == '/' ||
      key == ' ' ||
      key == '#'
    ) {
      this.keyDown += key;
      const id = this.keyDown.substring(0, 3);
      const ticketFormat = this.ListeTicketFormat.find(
        (e) => e.CashTicket_Nature == this.keyDown
      );
      // if (ticketFormat) {
      //   this.listTickets.push({
      //     codeComplete: this.keyDown,
      //     CashTicket_Code: id,
      //     CashTicket_Fournisseur: ticketFormat.CashTicket_Fournisseur,
      //     CashTicket_Libelle: ticketFormat.CashTicket_Libelle,
      //     CashTicket_Montant: Number(this.keyDown.substring(3, 9)) / 1000,
      //   });
      // }
    }

    if ((key == 'Enter') && this.keyDown != '') {
      if (this.isOnwaitingState) return;
      const id = this.keyDown.substring(0, 3);
      const ticketFormat = this.ListeTicketFormat.find(
        (e) => e.CashTicket_Nature == id
      );
      console.log(this.ListeTicketFormat);
      if (!id || !ticketFormat) {
        this.generalService.dialogSuccess('code invalid', false);
        console.log(this.ListeTicketFormat);
        console.log(this.TextVal);
        this.keyDown = ""
        return;
      }
      if (ticketFormat.CashTicket_Nb !== this.keyDown.length) {
        console.log(ticketFormat.CashTicket_Nb);

        this.generalService.dialogSuccess('code trop court', false);
        this.keyDown = ""
        return;
      }
      if (this.listTickets.find((t) => t.codeComplete == this.keyDown)) {
        this.generalService.dialogSuccess('Code deja exist !', false);
        this.keyDown = ""
        return;
      }
      if (ticketFormat) {
        console.log(!this.listTickets.find((t) => t.codeComplete == this.keyDown));
        if (!this.listTickets.find((t) => t.codeComplete == this.keyDown)) {
          this.listTickets.push({
            codeComplete: this.keyDown,
            CashTicket_Code: id,
            CashTicket_Fournisseur: ticketFormat.CashTicket_Fournisseur,
            CashTicket_Libelle: ticketFormat.CashTicket_Libelle,
            CashTicket_Montant: Number(this.keyDown.substring(3, 9)) / 1000,
          });
          console.log(this.listTickets);

          this.keyDown = ''
        }
        else {
          this.generalService.dialogSuccess('code déja existe', false);
        }
      }

    }
    if (key == 'Escape') {
      this.keyDown = '';
    }
    if (key == 'Backspace') {
      //let PrevKey = this.keyDown
      this.keyDown = this.keyDown.substring(
        0,
        this.keyDown.length - 1
      );
      // if (this.keyDown.length < 3) {
      //   this.listTickets.splice(this.listTickets.length - 1, 1);
      //   this.value = this.listTickets.reduce((a, b) => a + b.CashTicket_Montant, 0);
      // }
      // if (this.isOnwaitingState) return;
      // const id = this.keyDown.substring(0, 3);
      // const ticketFormat = this.ListeTicketFormat.find(
      //   (e) => e.CashTicket_Nature == id
      //);
      // if (this.listTickets.length !=0)
      //   if (this.listTickets[this.listTickets.length - 1].codeComplete == PrevKey) {
      //     this.listTickets.splice(this.listTickets.length - 1, 1);
      //     this.value = this.listTickets.reduce((a, b) => a + b.CashTicket_Montant, 0);
      //   }
      // if (!id || !ticketFormat) {
      //   return;
      // }
      // if (ticketFormat.CashTicket_Nb !== this.keyDown.length) {
      //   return;
      // }
      // if (this.listTickets.find((t) => t.codeComplete == this.keyDown)) {
      //   return;
      // }
      // this.listTickets.push({
      //   codeComplete: this.keyDown,
      //   CashTicket_Code: id,
      //   CashTicket_Fournisseur: ticketFormat.CashTicket_Fournisseur,
      //   CashTicket_Libelle: ticketFormat.CashTicket_Libelle,
      //   CashTicket_Montant: Number(this.keyDown.substring(3, 9)) / 1000,
      // });
    }
  }

  handleKeyDown(key, keyCode, event: Event) {
    // le focus et parfois se met au boutons liste article, new ticket.. si on appuit sur le clavier au btn Enter l'action sur le bouton qui à le focuse se declenche
    this.imgKastelo.nativeElement.focus();
    if (
      (keyCode > 47 && keyCode < 58) ||
      (keyCode > 64 && keyCode < 91) ||
      (keyCode >= 96 && keyCode <= 105) ||
      key == '-' ||
      key == '*' ||
      key == '_' ||
      key == '.' ||
      key == '/' ||
      key == ' ' ||
      key == '#'
    ) {
      this.articleTemp += key;
      this.keyDown += key;
      // this.openArticleList();
    }
    // if (this.articleTemp.length == this.waitedLength)
    if ((key == 'Enter' || key == 'Tab') && this.articleTemp != '') {
      console.log(1111);

      if (this.isOnwaitingState) return;
      this.isOnwaitingState = true;
      this.keyDownModeNewTicket();
    }
    if (key == 'Escape') {
      this.articleTemp = '';
    }

    if (key == 'Backspace') {
      this.articleTemp = this.articleTemp.substring(
        0,
        this.articleTemp.length - 1
      );
    }

  }
  LastItemTapped
  keyDownModeNewTicket() {
    console.log('hii');

    this.generalService
      .rechercheTable(
        'recherche/tbdata?tablere=articlef&param=' + this.articleTemp
      )
      .subscribe((data) => {
        this.isOnwaitingState = false;
        this.articleTemp = '';

        console.log(this.products);
        console.log(this.products.find((e) => e.Art_Code == data[0].Art_Code));
        if (data[0].Art_Remise != 0)
          data[0].PTAR = data[0].Art_PV - ((data[0].Art_PV * data[0].Art_Remise) / 100)
        else
          data[0].PTAR = data[0].Art_PV
        data[0]['Qte'] = 1
        console.log(data);
        console.log(this.products.find((e) => e.Art_Code == data[0].Art_Code));

        if (this.products.find((e) => e.Art_Code == data[0].Art_Code)) {
          this.products.find((e) => e.Art_Code == data[0].Art_Code).Qte += 1
          this.products.find((e) => e.Art_Code == data[0].Art_Code).PTAR += data[0].PTAR
          console.log(this.LastItemTapped);
          this.LastItemTapped = this.products.find((e) => e.Art_Code == data[0].Art_Code)

          this.addArticleDS(this.LastItemTapped, 1);
          // if (this.mode != 'ECHANGE')
          this.postAndGetDs()
          // this.generalService.postDs(this.dsDocCash).subscribe(res => {
          //   console.log(this.dsDocCash);
          //   this.LastItemTapped.Qte += 1
          //   this.generalService.getDS('doccashtemp', this.dsDocCash.DocCashTemp[0].Doc_Num).subscribe(res => {
          //     this.dsDocCash = res
          //     this.firstTimeIn = true
          //     this.sumPayed = 0
          //     if (this.dsDocCashR) {
          //       this.dsDocCashR.DocCashR[0] = this.generalService.clearFields(this.dsDocCashR.DocCashR[0])
          //       if (this.dsDocCashR.DocCashR[1])
          //         this.dsDocCashR.DocCashR.splice(1, this.dsDocCashR.DocCashR.length)
          //     }
          //   })
          //   this.openTicketTempList(false)
          //   // setTimeout(() => {
          //   //   this.updateTicketTemp(this.dsDocCash.DocCashTemp[0].Doc_Num)
          //   // }, 100);
          //   this.OpenTicketTemp(this.dsDocCash.DocCashTemp[0].Doc_Num)
          // })
        }
        else if (data.length > 0) {
          console.log('additem');
          this.addItem(data[0], 1);

          //console.log(data[0]);
          this.generalService.dialogSuccess('Ajouter', true, 500);
        } else
          this.generalService.dialogSuccess('Article non trouvé', false, 1000);
      });
    //this.updateTicketTemp(this.dsDocCash.DocCashTemp[0].Doc_Num)
  }

  stepperSelectionChange(event: StepperSelectionEvent) {
    this.selectedStepperIndex = event.selectedIndex;
    this.articleTemp = '';
    this.keyDown = '';
    this.ticketTemp = '';
  }

  printPrice() {
    console.log("********** "   +this.Doc_Num)
    this.webview2.postMessage(this.Doc_Num);
    console.log("*** ++++ ---- "   +this.Doc_Num)

    //this.generalService.print(this.Doc_Num).subscribe(console.log);
  }
  getProductsCount() {
    return this.products.reduce((a, b) => a + b.Qte, 0);
  }
  getDateInterval(end) {
    const res = {
      min: new Date(),
      max: new Date(new Date().setMonth(new Date().getMonth() + 6)),
    };
    return res[end];
  }
  showAddNewClient() {
    this.generalService.dialog.open(this.frmaddNewClient);
  }
  clearfieldAddClient() {
    this.clientToAdd.Tiers_RS = null
    this.clientToAdd.Tiers_Famille = null
    this.clientToAdd.Tiers_Adresse = null
    this.clientToAdd.Tiers_Ville = null
    this.clientToAdd.Tiers_Contact_mail = null
    this.clientToAdd.Tiers_Contact_Mobile = null
  }
  addNewClientRequest() {
    if (this.clientToAdd && this.clientToAdd.Tiers_RS != '') {
      console.log(this.clientToAdd);

      this.generalService.getDS('Client').subscribe((res: any) => {

        res.Tiers[0].Tiers_Type = '01';
        res.Tiers[0].Tiers_RS = this.clientToAdd.Tiers_RS;
        res.Tiers[0].Tiers_Famille = this.clientToAdd.Tiers_Famille;
        res.Tiers[0].Tiers_Adresse = this.clientToAdd.Tiers_Adresse;
        res.Tiers[0].Tiers_Ville = this.clientToAdd.Tiers_Ville;
        res.Tiers[0].Tiers_Contact_mail = this.clientToAdd.Tiers_Contact_mail;
        res.Tiers[0].Tiers_Contact_Mobile = this.clientToAdd.Tiers_Contact_Mobile;
        this.generalService.postDs(res).subscribe(
          () => {
            this.generalService.dialogSuccess(
              'Utilisateur Ajouter avec success !',
              true,
              1000
            );
            this.clearfieldAddClient()
            this.generalService.dialog.closeAll();
          },
          (err) => {
            this.generalService.dialogSuccess(
              "quelque chose s'est mal passé",
              false,
              1000
            );
            this.generalService.dialog.closeAll();
          }
        );
      });
    }
  }
  //#endregion
}

export function log(): MethodDecorator {
  return function (target: Function, key: string, descriptor: any) {
    const originalMethod = descriptor.value;

    descriptor.value = function (...args: any[]) {
      console.log(`Entering ${key} method`);
      const result = originalMethod.apply(this, args);
      console.log(`Leaving ${key} method`);

      return result;
    };

    return descriptor;
  };
}



// detectChangeProducts(newTabToshow, oldTab) {
  //   newTabToshow.forEach((element, index) => {
  //     console.log(element);
  //     console.log(newTabToshow);
  //     console.log(oldTab.find((e) => e.Art_Code == element.Art_Code));

  //     if (oldTab.find((e) => e.Art_Code == element.Art_Code)) {
  //       console.log(1);
  //       oldTab.find((e) => e.Art_Code == element.Art_Code).Qte = element.Qte
  //       oldTab.find((e) => e.Art_Code == element.Art_Code).PTAR = element.PTAR
  //     }
  //     else {

  //     }
  //   });
  // }

  //saveTicket() {
    // if (this.dsDocCash.DocCashD[0]) {
    //   this.generalService.getDS('doccashTemp').subscribe(res=>{
    //     this.generalService.fillObject(this.dsDocCash.DocCash[0],res['DocCashTemp'][0])
    //     res['DocCashTempD']=this.dsDocCash.DocCash
    //     console.log(res);
    //     this.generalService.postDs(res).subscribe(res=>{
    //       this.generalService.dialogSuccess(
    //         'Ajout avec succés',
    //         true
    //       );
    //     })
    //   },
    //   err=>{
    //     this.generalService.dialogSuccess(
    //       'Probléme de connexion',
    //       false
    //     );
    //   })
    //   console.log(this.dsDocCash);

    //   this.ListTicketTemp.push(this.dsDocCash)
    //   console.log(this.ListTicketTemp);
    //   this.newTicket()
    // }
    // else
    // this.generalService.dialogSuccess(
    //   'Aucun Article Sélectionné',
    //   false
    // );

 // }
 // updateTicketTemp(docNum) {
  //   console.log(docNum);

  //   let changevalues = false
  //   this.dsDocCash = null
  //   this.generalService.getDS('DocCashTemp', docNum).subscribe(res => {
  //     this.dsDocCash = res
  //     console.log(this.dsDocCash);
  //     console.log(this.dsDocCash.DocCashTemp[0].Doc_Num);
  //     if (this.dsDocCash.DocCashTemp[0].Doc_Num) {
  //       this.products = []
  //       this.dsDocCash.DocCashTempD.forEach(element => {
  //         console.log(element);
  //         if (element.Art_Code) {
  //           this.generalService.rechercheTable('recherche/tbdata?tablere=articlef&param=' + element.Art_Code
  //           )
  //             .subscribe((data) => {
  //               console.log(data);
  //               changevalues = true
  //               let obj = data[0]
  //               console.log(element);
  //               console.log(obj);
  //               obj.Art_Remise = element.DocCashD_TxRem
  //               if (obj.Art_Remise != 0)
  //                 obj.PTAR = (obj.Art_PV * obj.Art_Remise) / 100
  //               else
  //                 obj.PTAR = obj.Art_PV
  //               obj['Qte'] = 1
  //               if (this.products.find((e) => e.Art_Code == obj.Art_Code)) {
  //                 this.products.find((e) => e.Art_Code == obj.Art_Code).Qte++
  //                 this.products.find((e) => e.Art_Code == obj.Art_Code).PTAR += obj.PTAR
  //               }
  //               else {
  //                 this.products.push(obj)
  //                 this.ListProductToshow = this.products
  //               }
  //             })
  //           console.log(element.DocCashD_TxRem);
  //           if (element.DocCashD_TxRem != 0)
  //             element.DocCashD_PTTC = (element.DocCashD_PUHTB * element.DocCashD_TxRem) / 100
  //           else
  //             element.DocCashD_PTTC = element.DocCashD_PUHTB
  //         }
  //       }
  //       );
  //     }
  //     console.log("updateDs");
  //     console.log(this.products);
  //     if (changevalues) {
  //       console.log(111111111111);

  //       this.generalService.postDs(this.dsDocCash).subscribe(res => {
  //         this.generalService.getDS('doccashtemp', this.dsDocCash.DocCashTemp[0].Doc_Num).subscribe(res2 => {
  //         })
  //       })
  //       console.log(this.products);
  //       //this.products=this.dsDocCash.dsDocCashTempD
  //       if (this.dsDocCashR) {
  //         this.dsDocCashR.DocCashR = this.dsDocCashR.DocCashR = Object.assign({}, this.docCashToPost.DocCashR[0])
  //         console.log(this.dsDocCashR.DocCashR[0]);
  //       }
  //     }

  //   })

  //   console.log(this.ListProductToshow);
  //   //this.ListProductToshow = this.products
  //   // console.log(this.ListProductToshow);
  // }